$(document).ready(function() {
    $('.product-page--submit-action').click(function() {
        $('html').addClass('cart-drawer-open');
        $('.cart-charity-banner').show();
        $('.ajax-cart--bottom-wrapper').show();
           $('.cart-empty-box').removeClass('hide');
    });
    $('.slide-menu-cart').click(function() {
        $('html').addClass('cart-drawer-open');
    });

    // Keep html.cart-drawer-open in sync with drawer visibility.
    // Previously only added on ATC / cart icon — never removed on close.
    (function syncCartDrawerOpenClass() {
        var cartDrawer = document.querySelector('#cartSlideoutWrapper, .cart-drawer-right');
        if (!cartDrawer) {
            return;
        }

        function syncOpenClass() {
            var isHidden = cartDrawer.classList.contains('slideout-panel-hidden');
            document.documentElement.classList.toggle('cart-drawer-open', !isHidden);
            if (isHidden) {
                document.body.classList.remove('open-cart-drawer');
                // If cart closed but theme left slideout-open (no cart-drawer-open),
                // header CSS would shove #main-body +575px. Clear stuck shift.
                if (
                    document.documentElement.classList.contains('slideout-open') &&
                    !document.querySelector('.mobile-menu-wrapper:not(.slideout-panel-hidden)')
                ) {
                    document.documentElement.classList.remove('slideout-open');
                    var mainBody = document.querySelector('#main-body');
                    if (mainBody) {
                        mainBody.style.transform = '';
                        mainBody.style.webkitTransform = '';
                        mainBody.style.transition = '';
                        mainBody.style.webkitTransition = '';
                        mainBody.style.position = '';
                        mainBody.style.marginTop = '';
                    }
                    var overlay = document.getElementById('slideout-overlay');
                    if (overlay) {
                        overlay.style.display = 'none';
                    }
                }
            }
        }

        syncOpenClass();
        var observer = new MutationObserver(syncOpenClass);
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    })();

    // $(".cart_product").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     speed: 300,
    //     prevArrow: $('.prev-testimonial'),
    //     nextArrow: $('.next-testimonial'),
    //     responsive: [
    //         {
    //             breakpoint: 768,  
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         },
    //         {
    //             breakpoint: 480,  
    //             settings: {
    //                 slidesToShow: 1 
    //             }
    //         }
    //     ]
    // });


    //cart drawer free gift slider
    function initializeCartSlider1() {
        if (!$(".free-product .cart-drawer__recommendations-grid").hasClass("slick-initialized")) {
            $(".free-product .cart-drawer__recommendations-grid").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                speed: 300,
                prevArrow: $('#prev-free'),
                nextArrow: $('#next-free'),
                responsive: [
                    {
                        breakpoint: 768,  
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,  
                        settings: {
                            slidesToShow: 1 
                        }
                    }
                ]
            });
        } else {
            $(".free-product .cart-drawer__recommendations-grid").slick("setPosition");
        }
    }
    function onCartDrawerOpen1() {
        initializeCartSlider1();
    }
    function monitorCartDrawer1() {  
        let cartDrawer = document.querySelector('.cart-drawer-right');
        if (!cartDrawer) return;
        let slickTimer = null;
        let lastHidden = cartDrawer.classList.contains('slideout-panel-hidden');
        let observer = new MutationObserver(function() {
            const nowHidden = cartDrawer.classList.contains('slideout-panel-hidden');
            // Only init/refresh slick when drawer opens — not on every class tweak
            // (normalizing / empty / is-open), which froze the page 10–20s.
            if (nowHidden === lastHidden) return;
            lastHidden = nowHidden;
            if (nowHidden) return;
            clearTimeout(slickTimer);
            slickTimer = setTimeout(onCartDrawerOpen1, 200);
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    $(document).ready(function() {
        monitorCartDrawer1();
    });
    document.querySelector('.cart-drawer-right').addEventListener('open', function() {
        if ($('.free-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.free-product .cart-drawer__recommendations-grid').slick('setPosition'); 
        }
    });
    $(document).on('click', '.slide-menu-cart', function() {
        $('.cart-drawer-right').addClass('is-open');
        if ($('.free-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.free-product .cart-drawer__recommendations-grid').slick('setPosition');
        }
    });
    //cart drawer you may also like slider
    function initializeCartSlider() {
        if (!$(".like-product .cart-drawer__recommendations-grid").hasClass("slick-initialized")) {
            $(".like-product .cart-drawer__recommendations-grid").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                speed: 300,
                prevArrow: $('#prev-you-may-also-like'),
                nextArrow: $('#next-you-may-also-like'),
                responsive: [
                    {
                        breakpoint: 768,  
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,  
                        settings: {
                            slidesToShow: 1 
                        }
                    }
                ]
            });
        } else {
            $(".like-product .cart-drawer__recommendations-grid").slick("setPosition");
        }
    }
    function onCartDrawerOpen() {
        initializeCartSlider();
    }
    function monitorCartDrawer() {  
        let cartDrawer = document.querySelector('.cart-drawer-right');
        if (!cartDrawer) return;
        let slickTimer = null;
        let lastHidden = cartDrawer.classList.contains('slideout-panel-hidden');
        let observer = new MutationObserver(function() {
            const nowHidden = cartDrawer.classList.contains('slideout-panel-hidden');
            if (nowHidden === lastHidden) return;
            lastHidden = nowHidden;
            if (nowHidden) return;
            clearTimeout(slickTimer);
            slickTimer = setTimeout(onCartDrawerOpen, 200);
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    $(document).ready(function() {
        monitorCartDrawer();
    });
    document.querySelector('.cart-drawer-right').addEventListener('open', function() {
        if ($('.like-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.like-product .cart-drawer__recommendations-grid').slick('setPosition'); 
        }
    });
    $(document).on('click', '.slide-menu-cart', function() {
        $('.cart-drawer-right').addClass('is-open');
        if ($('.like-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.like-product .cart-drawer__recommendations-grid').slick('setPosition');
        }
    });
    
 
    //benefit slider js
    $('.benefit-slider').slick({
        rows: 3,
        infinite: SVGComponentTransferFunctionElement,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.prev-benefit'),
        nextArrow: $('.next-benefit'),
        responsive: [
            {
            breakpoint: 1199,
                settings: {
                slidesToShow: 1,
                }
            }
        ]
    });   
 

    //PDP add to cart
    // ATC-MEM: enable with window.__ATC_MEM_LITE = true; location.reload();
    if (typeof window.__atcMemLog === 'function') {
        window.__atcMemLog('custom.js ready');
    }

    // Keep sold-out swatches deactivated when theme toggles .soldout/.available
    function syncSoldOutSwatchDisabledState(root) {
        const scope = root || document;
        scope.querySelectorAll('#add-to-cart-form .swatch-element, #quickViewSlideoutWrapper .swatch-element').forEach(function (el) {
            const input = el.querySelector('input[type="radio"]');
            const label = el.querySelector('label');
            if (!input) return;

            const soldOut = el.classList.contains('soldout');
            input.disabled = soldOut;
            input.setAttribute('aria-disabled', soldOut ? 'true' : 'false');

            if (label) {
                if (soldOut) {
                    label.setAttribute('tabindex', '-1');
                    label.setAttribute('aria-disabled', 'true');
                } else {
                    label.setAttribute('tabindex', '0');
                    label.removeAttribute('aria-disabled');
                }
            }
        });
    }

    syncSoldOutSwatchDisabledState();

    const swatchRoot = document.querySelector('#add-to-cart-form') || document.body;
    const soldOutSwatchObserver = new MutationObserver(function () {
        syncSoldOutSwatchDisabledState(swatchRoot);
    });
    soldOutSwatchObserver.observe(swatchRoot, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });

});

$(document).ready(function() {

    // $('.product-page--submit-action').on('click', function(event) {

    //     if ($(event.target).is('button')) {
    //         event.preventDefault(); 
           
    //         setTimeout(function() {
    //             fetchAndUpdateCart();
    //         }, 1000); 
    //    }
    // });
   

});
